import { Button } from "antd";
import { motion } from "framer-motion";
import { IoDiamond } from "react-icons/io5";
import { MdVerified } from "react-icons/md";
import { Ad } from "../../../types/adType";
import AdsCard from "../../ads/AdsCard";

interface AdsSectionProps {
    title: string;
    ads: Ad[];
    displayType: "grid" | "list";
    isPremium?: boolean;
    isVerified?: boolean;
    favorites: Set<string>;
    isTogglingFavorite: Record<string, boolean>;
    onToggleFavorite: (ad: Ad) => void;
    onTabChange?: (tab: 'all' | 'premium' | 'verified') => void;
    activeTab?: 'all' | 'premium' | 'verified';
}

const AdsSection: React.FC<AdsSectionProps> = ({
    title,
    ads,
    displayType,
    isPremium = false,
    isVerified = false,
    favorites,
    isTogglingFavorite,
    onToggleFavorite,
    onTabChange,
    activeTab
}) => {
    if (ads.length === 0) return null;

    return (
        <div className="mb-8">
            <div className="flex items-center gap-2 mb-4">
                <h2 className="text-lg font-bold text-gray-800 flex items-center">
                    {title}
                    {isPremium && <IoDiamond size={20} className="ml-2 text-amber-500" />}
                    {isVerified && <MdVerified size={20} className="ml-2 text-blue-500" />}
                </h2>

                {isPremium && (
                    <span className="bg-gradient-to-r from-amber-100 to-amber-200 text-amber-700 text-xs px-2 py-0.5 rounded-full ml-auto">
                        Sponsorisé
                    </span>
                )}
            </div>

            <div className={`grid ${displayType === 'list' ? 'grid-cols-1' : 'grid-cols-2 md:grid-cols-3 lg:grid-cols-4'} gap-4`}>
                {ads.map((ad) => (
                    <motion.div
                        key={ad.id}
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.3 }}
                    >
                        <AdsCard
                            ad={ad}
                            images={ad.product_images?.map(img => img.url) || []}
                            list={displayType === 'list'}
                            isFavorite={favorites.has(ad.id)}
                            isTogglingFavorite={isTogglingFavorite[ad.id]}
                            onToggleFavorite={() => onToggleFavorite(ad)}
                        />
                    </motion.div>
                ))}
            </div>

            {isPremium && ads.length > 4 && activeTab !== 'premium' && (
                <div className="flex justify-center mt-6">
                    <Button
                        onClick={() => onTabChange?.('premium')}
                        className="bg-gradient-to-r from-amber-400 to-amber-500 text-white border-0 hover:from-amber-500 hover:to-amber-600"
                    >
                        Voir tous les articles VIP
                    </Button>
                </div>
            )}
        </div>
    );
};

export default AdsSection; 